import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 28,
    height: 28,
    fill: "transparent"
  }
});

class IcUser extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 28 28" } >
      <path d="M23.3334 24.5V22.1667C23.3334 20.929 22.8417 19.742 21.9665 18.8668C21.0913 17.9917 19.9044 17.5 18.6667 17.5H9.33335C8.09568 17.5 6.90869 17.9917 6.03352 18.8668C5.15835 19.742 4.66669 20.929 4.66669 22.1667V24.5" stroke="#1A1919" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 12.8333C16.5773 12.8333 18.6666 10.744 18.6666 8.16667C18.6666 5.58934 16.5773 3.5 14 3.5C11.4227 3.5 9.33331 5.58934 9.33331 8.16667C9.33331 10.744 11.4227 12.8333 14 12.8333Z" stroke="#1A1919" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcUser);